import React, { useEffect, useContext } from 'react';
import {
  doc,
  getDoc
} from 'firebase/firestore';

import {
  db
} from "../utils/firebase";

import { TokenContext } from "./tokenContext"; // import TokenContext
import { logout } from "../utils/firebase";
import { createPortal } from "react-dom";
import GlobalNavDrawer from "./GlobalNavDrawer";
import { useAuth } from './AuthContext';
import "./JobBankPages.css";

export default function JobBankHelp() {
  const { balance, setBalance } = useContext(TokenContext);
  const { currentUser } = useAuth();
  useEffect(() => {
        let isMounted = true;
    
        const fetchTokens = async () => {
          if (!currentUser?.uid) return;
    
          const userRef = doc(db, "users", currentUser.uid);
    
          try {
            const userDoc = await getDoc(userRef);
    
            if (userDoc.exists() && isMounted) {
              setBalance(userDoc.data().tokens ?? 0);
            }
          } catch (error) {
            console.error("Error fetching token count:", error);
          }
        };
    
        fetchTokens();
    
        return () => {
          isMounted = false;
        };
      }, [currentUser, setBalance]);

  return (

    <div className="JB-page">

      <div className="JB-hero">

        <h1>Help Centre</h1>

        <p>
          Everything you need to use the
          Community Job Bank effectively.
        </p>

      </div>

      <div className="JB-grid">

        <div className="JB-card">

          <h3>Job Bank</h3>

          <ul>
            <li>Search jobs</li>
            <li>Filter results</li>
            <li>Review job details</li>
            <li>Apply directly</li>
          </ul>

        </div>

        <div className="JB-card">

          <h3>Job Seeker Profile</h3>

          <ul>
            <li>Create profile</li>
            <li>Upload resume</li>
            <li>Add certifications</li>
            <li>Track applications</li>
          </ul>

        </div>

        <div className="JB-card">

          <h3>Employer Portal</h3>

          <ul>
            <li>Create jobs</li>
            <li>Manage jobs</li>
            <li>Review applicants</li>
            <li>Message candidates</li>
          </ul>

        </div>

        <div className="JB-card">

          <h3>Career Coach Portal</h3>

          <ul>
            <li>Manage clients</li>
            <li>Review readiness</li>
            <li>Track outcomes</li>
            <li>Support employers</li>
          </ul>

        </div>

        <div className="JB-card">

          <h3>Hiring Events</h3>

          <ul>
            <li>Create events</li>
            <li>Manage registration</li>
            <li>Track attendance</li>
            <li>Connect employers</li>
          </ul>

        </div>

        <div className="JB-card">

          <h3>Messaging</h3>

          <ul>
            <li>Candidate ↔ Employer</li>
            <li>Interview scheduling</li>
            <li>Status updates</li>
            <li>Conversation history</li>
          </ul>

        </div>

      </div>
      {createPortal(
        <GlobalNavDrawer
          hideCurrent
          links={[
            { to: "/purchase", label: `Tokens: ${balance}`},
            { to: "/jobbank", label: "Job Bank Home"},
            { to: "/voicebot", label: "iSpeakWell" },
            { to: "/resumerevisor", label: "Resumes" },
            { to: "/conversationpractice", label: "Convos" },
            { to: "/interview-practice", label: "Interviews" },
            { to: "/termsofservice", label: "Terms" },
            { to: "/privacypolicy", label: "Privacy" },
            { to: "/admin", label: "Admin" },
            { to: "/login", label: "Logout", onClick: async () => { await logout(); } },
          ]}
        />,
          document.body
      )}
    </div>

  );
}